import { Component, computed, inject } from '@angular/core';
import { CatalogueService } from '@catalogue';
import { provideTranslationDictionaryMapping, TranslatePipe } from '@i18n';
import { format } from 'date-fns';
import { DescriptionListItemComponent } from '../description-list-item/description-list-item.component';
import { DescriptionListComponent } from '../description-list/description-list.component';
import { translation } from './i18n/translation.constant';

@Component({
  selector: 'app-registered-appliance-summary',
  templateUrl: './registered-appliance-summary.component.html',
  styleUrl: './registered-appliance-summary.component.scss',
  imports: [
    DescriptionListComponent,
    DescriptionListItemComponent,
    TranslatePipe,
  ],
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegisteredApplianceSummaryComponent {
  private readonly catalogueService = inject(CatalogueService);
  readonly warrantyLengthInYearsLabel =
    this.catalogueService.warrantyLengthInYears();
  readonly appliance = this.catalogueService.steppedFormAppliance;
  readonly applianceModelNumber =
    this.catalogueService.selectedApplianceModelNumber;

  readonly appliancePurchaseDate = computed(() =>
    format(
      this.catalogueService.selectedAppliancePurchaseDate(),
      'do MMMM yyyy',
    ),
  );
}
